import { StateProvider } from '@uirouter/angularjs';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import UserService from '../../common/services/user/user.service';
import NoAuthService from '../services/noauth.service';
import NoAuthPackagesService from '../services/noauth-packages.service';

export default function ($stateProvider: StateProvider) {
  'ngInject';

  $stateProvider.state('noAuthBuy', {
    component: 'fizyPaycellNoAuthBuy',
    parent: 'noAuth',
    resolve: {
      packet: [
        '$q',
        '$state',
        '$stateParams',
        'i18n',
        'noAuthService',
        'noAuthPackagesService',
        'userService',
        'globalSpinner',
        function (
          $q,
          $state,
          $stateParams,
          i18n,
          noAuthService: NoAuthService,
          noAuthPackagesService: NoAuthPackagesService,
          userService: UserService,
          globalSpinner: GlobalSpinnerService
        ) {
          if (!$stateParams.packetId) {
            return $q.reject('Package not found');
          }
          var param = $stateParams.packetId;
          globalSpinner.startIfNotActivated();

          if ($stateParams.msisdn && $stateParams.msisdn.length === 12 && $stateParams.msisdn.startsWith("90")) {
            var cleanedMsisdn = $stateParams.msisdn.substring(2);
            return $state.go('noAuthBuy', { 
              packetId: $stateParams.packetId, 
              msisdn: cleanedMsisdn,
              promocode: $stateParams.promocode
            }, { location: 'replace' });
          }

          if (['premium', 'student', 'family', 'duo'].indexOf(param.toLowerCase()) > -1) {
            return noAuthService.getOfferIdFromType(param)
              .then(offerId => {
                if (offerId) {
                  $state.go('noAuthBuy', { packetId: offerId });
                } else {
                  userService.redirectToLogin();
                }
              })
              .catch(() => userService.redirectToLogin())
              .finally(() => globalSpinner.stop());
          }

          if (!i18n.cookieExists()) {
            i18n.shareLanguage(i18n.getCurrentLanguage());
          }

          return noAuthService
            .getPackageFromOfferId(param)
            .then(packet => noAuthPackagesService.convertListeningPackage(packet))
            .catch(() => userService.redirectToLogin())
            .finally(() => globalSpinner.stop());
        }
      ],
    },
    url: '/buy/:packetId?msisdn&promocode'
  });
}



// WEBPACK FOOTER //
// ./src/app/no-auth/buy/buy.routes.ts